<template lang="pug">
.themenu(v-shortcuts="[{ shortcut: [ 'f9', ], callback: shortcuts, push: true, focus: true },]")
  modal-shortcuts
  .nav-bar
    img#logo(src="@/assets/logo.svg")
    vm-navbar(class="sub-nabar" color="primary" text-color="rgba(122,171,252,1)", active-text-color="rgba(255,255,255,1)" type="flat")
      vm-navbar-item.menu_item(index="0" v-for="(item, i) in menuItems" :key="i")
        router-link(:to='item.link')
          vm-icon#router_icon(:icon="item.icon" size="1.4rem")
        router-link#router_span(:to='item.link')
          span.item_name {{ $t(item.name) }}
    .bottom-menu
      vm-dropdown(vm-position="right" vm-trigger-click)
        vm-button.help(type="flat" radius color="secondary" text-color="#fff" icon="question-mark-circle" @click="")

        vm-dropdown-menu
          vm-dropdown-group(vm-label="Ayuda")
            vm-dropdown-item Documentacion
            vm-dropdown-item(@click="shortcuts()") {{ $t('strings.shortcuts') }}
          vm-dropdown-group(vm-label="Legal")
            vm-dropdown-item Términos de uso
            vm-dropdown-item Política de privacidad
      vm-button.help(type="flat" radius color="black" text-color="#ebebeb" icon="settings-outline" @click="")
  .sub-menu
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const ModalShortcuts = () => import('@/components/aditionals/ModalShortcuts.vue')

export default {
  name: 'TheMenu',
  components: {
    ModalShortcuts
  },
  data: () => ({
    activeItem: 0
  }),
  computed: {
    ...mapGetters([
      'menuItems'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShortcutsVisible'
    ]),
    shortcuts () {
      this.setModalShortcutsVisible(true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#logo {
  padding-top: 1rem;
  width: 2.5rem;
  margin-left: 0.7rem;
}
.themenu {
  height: 100%;
  display: flex;
  width: 75px;
  background: rgba(var(--primary),1);
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
  .nav-bar {
    position: relative;
  .sub-nabar{
    width: 75px;
    transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
    display: block;
    transform: translateY(-50%);
    top: 40%;
    .vm-navbar--item {
      padding: 5px;
      display: flex;
      .router-link-active {
        #router_icon {
          color: gray;
        }
      }
        i {
          color: #FFF;
        }
        ~.vm-navbar-after {
            width: 100%;
        }
      }
      span {
        margin-top: 3px;
      }
      a {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 10px;
        padding: 10px 22px;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: background 0.4s linear;
      }
    }
  }
}
#router_icon {
  color: white;
}
#router_span {
  display: none;
  color: white;
}
.menu_item:hover {
  #router_icon,
  #router_span {
    color: gray;
  }
}
.themenu:hover {
  width: 200px;
  .sub-nabar {
    width: 200px;
  }
  #router_span {
    display: inherit;
  }
}
.bottom-menu {
  position: absolute;
  bottom: 24px;
  width: 65px;
  left: 18%;
  .help {
    cursor: pointer !important;
    pointer-events: inherit;
    .vm-icon {
      font-size: 1.3rem;
    }
  }
}
.heading {
  min-width: 180px;
  padding: 2px 12px;
  h4 {
    padding-top: 3px;
  }
}
.nonotifications {
  text-align: center;
}
</style>
